/* The mockup's `#toasts`: centred above the bottom edge, newest last. */
.region {
  position: fixed;
  inset-block-end: 64px;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  max-inline-size: 92vw;
  pointer-events: none;
}

/* The mockup's `.toast`: an inverted pill-card, the tone said by its glyph and its role. */
.toast {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 6px 6px 6px 14px;
  border-radius: var(--radius-card);
  background-color: var(--toast-surface);
  color: var(--toast-text);
  font-size: var(--font-size-13);
  box-shadow: var(--shadow-popover);
  pointer-events: auto;
  animation: toast-in var(--motion-duration) var(--motion-ease);
}

.stack {
  display: contents;
}

.glyph {
  display: inline-flex;
  flex: none;
}

.message {
  flex: 1 1 auto;
  line-height: 1.4;
}

/* The dismiss button sits on the inverted surface, so it takes the toast's text colour. */
.toast button {
  color: var(--toast-text);
}

.toast button:hover:not(:disabled) {
  background: var(--state-hover);
  color: var(--toast-text);
}

.info,
.success,
.danger {
  border: 0;
}

/*
 * The accessible name of the dismiss button, visible to assistive technology
 * and not to the eye. It is real text from the dictionary rather than an
 * `aria-label`, so the string travels the same path as every other one.
 */
.dismissLabel {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
